import React, {Component, Fragment, useState} from 'react';
import {connect, useDispatch} from 'react-redux';

import {Button, Confirm, crudUpdateMany} from 'react-admin';
import IconKeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Drawer from '@material-ui/core/Drawer';


const ReferenceAddBulkButton = ({label, basePath, selectedIds, resource, source, value }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
        const handleConfirm = () => {
            dispatch(crudUpdateMany(resource, selectedIds, {[source]: value}, basePath));
        }

        return <Fragment>
            <Button label={label} onClick={() => setOpen(true)} />
            <Drawer anchor="right" open={open}
                    onClose={() => setOpen(false)}

            >
                <div style={{padding: '1em'}}>
                    <Button label="Close" onClick={() => setOpen(false)}>
                        <IconKeyboardArrowRight />
                    </Button>
                    <h2>
                        Updating {selectedIds.length} {resource} items:
                    </h2>
                </div>


                <Button label="Confirm" onClick={() => {
                    setOpen(false);
                    handleConfirm();
                }} />
            </Drawer>
        </Fragment>
}

export const BulkAddGenreButton = (props) => (
    <ReferenceAddBulkButton label={"Add Genre"} source={"genres"} {...props}/>
);
